import MuiIconButton from "@material-ui/core/IconButton";
import { forwardRef, MouseEventHandler, ReactNode } from "react";

import { StylableProps } from "@rewards-web/shared/types";

interface IconButtonProps extends StylableProps {
  children: ReactNode;
  onClick: MouseEventHandler<HTMLButtonElement>;
  "aria-label": string;
  disabled?: boolean;
  color?: "default" | "inherit" | "primary" | "secondary";
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    { className, children, onClick, "aria-label": ariaLabel, disabled, color },
    ref
  ): JSX.Element => {
    return (
      <MuiIconButton
        ref={ref}
        className={className}
        aria-label={ariaLabel}
        onClick={onClick}
        disabled={disabled}
        color={color}
      >
        {children}
      </MuiIconButton>
    );
  }
);
